/**
 * Botão de levantar a mão na barra do RealtimeKit, ao lado do microfone e da câmera.
 * A barra vive em shadow roots e remonta; o botão é recolocado quando some.
 */

const BUTTON_ATTR = "data-constela-raise-hand";

type HandControlState = {
  raised: boolean;
  busy: boolean;
  onToggle: () => void;
};

function paint(button: HTMLButtonElement, state: HandControlState): void {
  button.disabled = state.busy;
  button.setAttribute("aria-pressed", state.raised ? "true" : "false");
  button.title = state.raised ? "Abaixar a mão" : "Pedir para falar";
  button.setAttribute("aria-label", button.title);
  button.style.background = state.raised ? "#f59e0b" : "#92400e";
  button.style.opacity = state.busy ? "0.55" : "1";
  button.textContent = "✋";
}

function placeButton(host: Element, state: HandControlState): void {
  const camera = host.querySelector("rtk-camera-toggle, dyte-camera-toggle");
  if (!camera || !camera.parentElement) return;

  let button = host.querySelector(`button[${BUTTON_ATTR}]`) as HTMLButtonElement | null;
  if (!button) {
    button = document.createElement("button");
    button.type = "button";
    button.setAttribute(BUTTON_ATTR, "true");
    button.style.width = "40px";
    button.style.height = "40px";
    button.style.borderRadius = "999px";
    button.style.border = "0";
    button.style.color = "#fff";
    button.style.fontSize = "18px";
    button.style.lineHeight = "1";
    button.style.cursor = "pointer";
    button.style.flex = "0 0 auto";
  }

  button.onclick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    state.onToggle();
  };

  paint(button, state);
  if (camera.nextElementSibling !== button) {
    camera.insertAdjacentElement("afterend", button);
  }
}

function walk(node: ParentNode, state: HandControlState): void {
  const elements =
    node instanceof Element
      ? [node, ...Array.from(node.querySelectorAll("*"))]
      : Array.from(node.querySelectorAll("*"));

  for (const el of elements) {
    if (!(el instanceof HTMLElement)) continue;
    const id = el.id;
    if (id === "controlbar-center" || id === "controlbar-mobile") {
      placeButton(el, state);
    }
    if (el.shadowRoot) walk(el.shadowRoot, state);
  }
}

export function syncRaiseHandControl(root: ParentNode | null, state: HandControlState): void {
  if (!root) return;
  walk(root, state);
}
